"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _objectPath = _interopRequireDefault(require("object-path"));

var _video = _interopRequireDefault(require("video.js"));

require("video.js/dist/video-js.css");

require("./index.css");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
} // as of videojs 7.6.0


var DEFAULT_EVENTS = ['loadeddata', 'canplay', 'canplaythrough', 'play', 'pause', 'waiting', 'playing', 'ended', 'error'];
var defaultState = {
  options: {
    controls: true,
    // 是否显示控制条
    controlBar: {
      // 显示控制条内容
      timeDivider: true,
      // 时间分割线
      durationDisplay: true,
      // 显示时间
      remainingTimeDisplay: false,
      // 剩余时间显示
      fullscreenToggle: true,
      // 切换全屏
      subtitlesButton: true // 字幕按钮

    },
    techOrder: ['html5'],
    autoplay: false,
    // 自动播放
    muted: false,
    loop: false,
    // 循环播放
    preload: 'none',
    // 预加载
    // language: 'zh', // 展示语言
    aspectRatio: '16:9',
    // 比例
    fluid: true,
    poster: '',
    // 封面图
    sources: [],
    subtitles: [],
    // 字幕
    defaultSubtitle: '' // 默认字幕
    // width: document.documentElement.clientWidth,

  },
  playInline: true,
  crossOrigin: ''
};

var ReactAwesomePlayer =
/*#__PURE__*/
function (_React$Component) {
  _inherits(ReactAwesomePlayer, _React$Component);

  function ReactAwesomePlayer() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, ReactAwesomePlayer);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(ReactAwesomePlayer)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "video", null);

    _defineProperty(_assertThisInitialized(_this), "state", defaultState);

    return _this;
  }

  _createClass(ReactAwesomePlayer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var sources = (0, _objectPath["default"])(this.props).get('options.sources') || [];
      var isSource = sources.length;

      if (!this.player && isSource) {
        this.initialize();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.player && this.props.options !== prevProps.options) {
        this.resetUrl();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.player) {
        this.player.dispose();
      }
    }
  }, {
    key: "resetUrl",
    value: function resetUrl() {
      var sources = (0, _objectPath["default"])(this.props).get('options.sources') || [];
      sources[0] && this.player.src(sources[0].src);
      this.player.poster(this.props.options.poster);
    }
  }, {
    key: "initialize",
    value: function initialize() {
      var _this2 = this;

      if (this.state.playInline) {
        this.video.setAttribute('webkit-playsinline', true);
        this.video.setAttribute('playsInline', true);
        this.video.setAttribute('x5-playsinline', true);
        this.video.setAttribute('x5-video-player-type', 'h5');
        this.video.setAttribute('x5-video-player-fullscreen', false);
      } // cross origin


      if (this.state.crossOrigin !== '') {
        this.video.crossOrigin = this.state.crossOrigin;
        this.video.setAttribute('crossOrigin', this.state.crossOrigin);
      } // avoid error "VIDEOJS: ERROR: Unable to find plugin: __ob__"


      if (this.state.options.plugins) {
        delete videoOptions.plugins.__ob__;
      }

      this.setState({
        options: _objectSpread({}, this.state.options, {}, this.props.options)
      }, function () {
        var context = _this2;
        _this2.player = (0, _video["default"])(_this2.video, _this2.state.options, function () {
          var _this3 = this; // events


          var events = DEFAULT_EVENTS.concat(context.props.events); // watch events

          var onEdEvents = {};

          for (var i = 0; i < events.length; i += 1) {
            if (typeof events[i] === 'string' && onEdEvents[events[i]] === undefined) {
              (function (event) {
                onEdEvents[event] = null;

                _this3.on(event, function () {
                  if (typeof context.props[event] === 'function') context.props[event](true);
                });
              })(events[i]);
            }
          } // watch timeupdate


          this.on('timeupdate', function () {
            if (typeof context.props.timeupdate === 'function') context.props.timeupdate(this.currentTime());
          });
        });
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      var _this$state$options = this.state.options,
          subtitles = _this$state$options.subtitles,
          defaultSubtitle = _this$state$options.defaultSubtitle;
      return _react["default"].createElement("div", {
        className: "react-awesome-player-container"
      }, _react["default"].createElement("video", {
        className: "video-js react-awesome-player",
        ref: function ref(video) {
          _this4.video = video;
        }
      }, subtitles && subtitles.map(function (item, index) {
        return _react["default"].createElement("track", {
          key: index,
          src: item.url,
          kind: "captions",
          srcLang: item.language,
          label: item.label,
          "default": item.language === defaultSubtitle
        });
      })));
    }
  }]);

  return ReactAwesomePlayer;
}(_react["default"].Component);

_defineProperty(ReactAwesomePlayer, "defaultProps", {
  options: {}
});

ReactAwesomePlayer.propTypes = {
  options: _propTypes["default"].object,
  defaultSubtitle: _propTypes["default"].string,
  events: _propTypes["default"].array,
  // events props
  loadeddata: _propTypes["default"].func,
  canplay: _propTypes["default"].func,
  canplaythrough: _propTypes["default"].func,
  play: _propTypes["default"].func,
  pause: _propTypes["default"].func,
  waiting: _propTypes["default"].func,
  playing: _propTypes["default"].func,
  ended: _propTypes["default"].func,
  error: _propTypes["default"].func,
  timeupdate: _propTypes["default"].func
};
var _default = ReactAwesomePlayer;
exports["default"] = _default;